import type { CloudItem } from 'reactApp/modules/storage/storage.types';
import type { ActionName } from 'reactApp/ui/VirusDialog/VirusDialog.types';

export const popupNames = {
    CO_EDIT_ALERT: 'CO_EDIT_ALERT',
    SPACE_PROMO: 'SPACE_PROMO',
    WEB_PUSH_TOOLTIP: 'WEB_PUSH_TOOLTIP',
    DOWNLOAD_DLG: 'DOWNLOAD_DLG',
    VIRUS_DLG: 'VIRUS_DLG',
    NO_WARNING: 'NO_WARNING',
    DISABLED_FEATURE: 'DISABLED_FEATURE',
    RECOGNITION_POPUP: 'RECOGNITION_POPUP',
    NEW_RECOGNITION_POPUP: 'NEW_RECOGNITION_POPUP',
    PERSONAL_DOCUMENT_GROUPS: 'PERSONAL_DOCUMENT_GROUPS',
    FILE_HISTORY: 'FILE_HISTORY',
    SELECT_FOLDER_DIALOG: 'SELECT_FOLDER_DIALOG',
    SELECT_PATH_DIALOG: 'SELECT_PATH_DIALOG',
    REMOVE_DIALOG: 'REMOVE_DIALOG',
    REPORT_DIALOG: 'REPORT_DIALOG',
    RENAME_DIALOG: 'RENAME_DIALOG',
    ASK_NAME_DIALOG: 'ASK_NAME_DIALOG',
    CREATE_FOLDER: 'CREATE_FOLDER',
    CREATE_FAMILY_FOLDER: 'CREATE_FAMILY_FOLDER',
    CREATE_DOCUMENT: 'CREATE_DOCUMENT',
    UPDATE_CARD: 'UPDATE_CARD',
    TARIFF_BUY: 'TARIFF_BUY',
    CONFIRM_EMAIL_SCREEN: 'CONFIRM_EMAIL_SCREEN',
    CONFIRM_EMAIL_DIALOG: 'CONFIRM_EMAIL_DIALOG',
    CANCEL_MAIL_SUBSCRIPTION: 'CANCEL_MAIL_SUBSCRIPTION',
    VKBUY_MODAL: 'VKBUY_MODAL',
    BUY_DISABLE_ADS: 'BUY_DISABLE_ADS',
    BUY_FOR_SAFE: 'BUY_FOR_SAFE',
    BUY_MSP_PRO: 'BUY_MSP_PRO',
    MOUNT_DIALOG: 'MOUNT_DIALOG',
    UNMOUNT_DIALOG: 'UNMOUNT_DIALOG',
    REJECT_DIALOG: 'REJECT_DIALOG',
    SHARING_DIALOG: 'SHARING_DIALOG',
    BIZ_PUBLIC_PASSWORD_DIALOG: 'BIZ_PUBLIC_PASSWORD_DIALOG',
    BIZ_DELETE_PUBLIC_PASSWORD: 'BIZ_DELETE_PUBLIC_PASSWORD',
    SHARING_MODIFIED: 'SHARING_MODIFIED',
    PRE_OVERQUOTA_MODAL: 'PRE_OVERQUOTA_MODAL',
    PRE_OVERQUOTA_MODAL_MOBILE: 'PRE_OVERQUOTA_MODAL_MOBILE',
    OVERQUOTA_MODAL: 'OVERQUOTA_MODAL',
    OVERQUOTA_VIEWER_MODAL: 'OVERQUOTA_VIEWER_MODAL',
    OVERQUOTA_SPLASH: 'OVERQUOTA_SPLASH',
    DATALIST: 'DATALIST',
    DOWNLOAD_MOBILE: 'DOWNLOAD_MOBILE',
    MOBILE_OPTIONS: 'MOBILE_OPTIONS',
    MOBILE_FILTER_AUTHOR: 'MOBILE_FILTER_AUTHOR',
    MOBILE_FILTER_FACES: 'MOBILE_FILTER_FACES',
    MOBILE_VIEWER: 'MOBILE_VIEWER',
    AUTH_MODAL: 'AUTH_MODAL',
    MOBILE_VIRUS_DIALOG: 'MOBILE_VIRUS_DIALOG',
    MOBILE_FILE_INFO_MODAL: 'MOBILE_FILE_INFO_MODAL',
    MOBILE_SUSPICIOS_DIALOG: 'MOBILE_SUSPICIOS_DIALOG',
    MOBILE_GIFT_PROMOCODE_DIALOG: 'MOBILE_GIFT_PROMOCODE_DIALOG',
    MOBILE_SPLASH_SCREEN: 'MOBILE_SPLASH_SCREEN',
    MOBILE_LEFT_MENU: 'MOBILE_LEFT_MENU',
    SUSPICIOS_DIALOG: 'SUSPICIOS_DIALOG',
    SELECT_ALBUM: 'SELECT_ALBUM',
    SELECT_CUSTOM_ALBUM: 'SELECT_CUSTOM_ALBUM',
    SELECT_VIGBO_ALBUM: 'SELECT_VIGBO_ALBUM',
    DISABLE_ADS_PROMO: 'DISABLE_ADS_PROMO',
    SPECIAL_BANNER: 'SPECIAL_BANNER',
    WHATS_NEW_DIALOG: 'WHATS_NEW_DIALOG',
    WHATS_NEW_DIALOG_MOBILE: 'WHATS_NEW_DIALOG_MOBILE',
    CONFIRM_EMAIL_MOBILE: 'CONFIRM_EMAIL_MOBILE',
    EMERGENCY_SWA: 'EMERGENCY_SWA',
    BANNER_OFFER: 'BANNER_OFFER',
    BANNER_OFFER_REDESIGN: 'BANNER_OFFER_REDESIGN',
    SUBSCRIPTIONS_MOBILE: 'SUBSCRIPTIONS_MOBILE',
    SUBSCRIPTION_INFO_MOBILE: 'SUBSCRIPTION_INFO_MOBILE',
    SELECT_FROM_CLOUD_DIALOG: 'SELECT_FROM_CLOUD_DIALOG',
    SUBSCRIPTION_CANCEL_AUTO_RENEWAL_MOBILE: 'SUBSCRIPTION_CANCEL_AUTO_RENEWAL_MOBILE',
    SUBSCRIPTION_CANCEL_SUBSCRIPTION_MOBILE: 'SUBSCRIPTION_CANCEL_SUBSCRIPTION_MOBILE',
    SUBSCRIPTION_CANCEL_WITH_CAPTCHA: 'SUBSCRIPTION_CANCEL_WITH_CAPTCHA',
    MUST_ATTACH_PHONE: 'MUST_ATTACH_PHONE',
    SUCCESS_ATTACH_PHONE: 'SUCCESS_ATTACH_PHONE',
    PAY_IN_BROWSER: 'PAY_IN_BROWSER',
    CLEAR_TRASHBIN: 'CLEAR_TRASHBIN',
    MOBILE_DOWNLOAD_APP: 'MOBILE_DOWNLOAD_APP',
    POLL_DIALOG: 'POLL_DIALOG',
    DELETE_CONFIRMATION_DIALOG: 'DELETE_CONFIRMATION_DIALOG',
    QUOTA_CLEANER_PAGE: 'QUOTA_CLEANER_PAGE',
    QUOTA_CLEANER_PAGE_MOBILE: 'QUOTA_CLEANER_PAGE_MOBILE',
    QUOTA_MOBILE_NAVIGATION: 'QUOTA_MOBILE_NAVIGATION',
    GENERIC_CONFRIMATION_DIALOG: 'GENERIC_CONFRIMATION_DIALOG',
    UPLOAD_BIG_FILE: 'UPLOAD_BIG_FILE',
    QUOTA_POPUP: 'QUOTA_POPUP',
    REMOVE_CARD: 'REMOVE_CARD',
    PRE_COPY_WEBLINK: 'PRE_COPY_WEBLINK',
    SUBSCRIPTION_MODAL: 'SUBSCRIPTION_MODAL',
    MOBILE_USER_CHANGE_MODAL: 'MOBILE_USER_CHANGE_MODAL',
    MOBILE_USER_LOGIN_MENU: 'MOBILE_USER_LOGIN_MENU',
    VIOLATED_FILENAME: 'VIOLATED_FILENAME',
    MOBILE_SEARCH_NOTIFICATION: 'MOBILE_SEARCH_NOTIFICATION',
    MOBILE_SEARCH_HISTORY_NOTIFICATION: 'MOBILE_SEARCH_HISTORY_NOTIFICATION',
    MOBILE_CLOUD_NEW_FEATURES: 'MOBILE_CLOUD_NEW_FEATURES',
    ASIDE_PROMO_MODAL: 'ASIDE_PROMO_MODAL',
    BUY_BUSINESS_DIALOG: 'BUY_BUSINESS_DIALOG',
    AUTH_DIALOG: 'AUTH_DIALOG',
    SMALL_WINDOW_WARNING_DIALOG: 'SMALL_WINDOW_WARNING_DIALOG',
    NOT_DOCUMENT_MODAL: 'NOT_DOCUMENT_MODAL',
    MOBILE_DISCOUNTS: 'MOBILE_DISCOUNTS',
    YEAR_FILTER_MODAL: 'YEAR_FILTER_MODAL',
    CREATE_COPY_OF_NONEDITABLEFILE: 'CREATE_COPY_OF_NONEDITABLEFILE',
    PROMOCODE_RESULT: 'PROMOCODE_RESULT',
    BUY_MODAL: 'BUY_MODAL',
    EBOOK_READER: 'EBOOK_READER',
    SLIDER_MODAL: 'SLIDER_MODAL',
    FAMILY_INVITE_MODAL: 'FAMILY_INVITE_MODAL',
    FAMILY_ACCEPT_INVITE: 'FAMILY_ACCEPT_INVITE',
    FAMILY_ERROR: 'FAMILY_ERROR',
    MOBILE_PUBLIC_BANNER: 'MOBILE_PUBLIC_BANNER',
    IMAGE_EDITOR: 'IMAGE_EDITOR',
    CONVERT_FB2_TO_EPUB: 'CONVERT_FB2_TO_EPUB',
    SAFE_FAKEDOOR: 'SAFE_FAKEDOOR',
    MOBILE_REQUIRED_SIGNUP: 'MOBILE_REQUIRED_SIGNUP',
    CREATE_NEW_DOCUMENT_BY_LINK: 'CREATE_NEW_DOCUMENT_BY_LINK',
    FAMILY_TARIFF_MODAL: 'FAMILY_TARIFF_MODAL',
    UPSALE_MONTH_TARIFF: 'UPSALE_MONTH_TARIFF',
    MOBILE_APP_QR: 'MOBILE_APP_QR',
    DELETE_PAGE_MODAL: 'DELETE_PAGE_MODAL',
    DELETE_PAGE_REJECTED_MODAL: 'DELETE_PAGE_REJECTED_MODAL',
    RENEW_SUBSCRIPTION_MODAL: 'RENEW_SUBSCRIPTION_MODAL',
    // tempexp_16481-start
    AUTOUPLOAD_PROMO_SUCCESS: 'AUTOUPLOAD_PROMO_SUCCESS',
    SUBSCRIPTION_CANCEL_AUTOUPLOAD: 'SUBSCRIPTION_CANCEL_AUTOUPLOAD',
    SUBSCRIPTION_CANCEL_10TB: 'SUBSCRIPTION_CANCEL_10TB',
    // tempexp_16481-end
    // tempexp_16800-next-line
    DETAILED_TARIFF_BENEFITS: 'DETAILED_TARIFF_BENEFITS',
    // tempexp_17086-next-line
    WELCOME_DEFAULT_TARIFF_SPLASH: 'WELCOME_DEFAULT_TARIFF_SPLASH',
    // tempexp_16598-next-line
    SUBSCRIPTION_CANCEL_NO_ADS: 'SUBSCRIPTION_CANCEL_NO_ADS',
    UPSALE_WITH_TRIAL: 'UPSALE_WITH_TRIAL',
    UNSAVED_CHANGES_MODAL: 'UNSAVED_CHANGES_MODAL',
    SHARING_PUBLIC_THEME_TARIFFS_MODAL: 'SHARING_PUBLIC_THEME_TARIFFS_MODAL',
    PAUSE_SUBSCRIPTION: 'PAUSE_SUBSCRIPTION',
    PAUSE_SUBSCRIPTION_SUCCESS: 'PAUSE_SUBSCRIPTION_SUCCESS',
    REBRANDING_PROMO_MODAL: 'REBRANDING_PROMO_MODAL',
    // tempexp_17439-start
    REFERRAL_PROGRAM_PROMO_MODAL: 'REFERRAL_PROGRAM_PROMO_MODAL',
    // tempexp_17439-end
    THANKS_MODAL: 'THANKS_MODAL',
    // tempexp_17509-next-line
    LITRES_SUCCESS_DIALOG: 'LITRES_SUCCESS_DIALOG',
    // tempexp_17532-next-line
    LITRES_MODAL: 'LITRES_MODAL',
    DELETE_PUBLIC_PASSWORD: 'DELETE_PUBLIC_PASSWORD',
    // tempexp_17825-next-line
    UNLINK_CARD_CONFIRM_MODAL: 'UNLINK_CARD_CONFIRM_MODAL',
    PUBLIC_PASSWORD_TARIFF_MOBILE: 'PUBLIC_PASSWORD_TARIFF_MOBILE',
    PUBLIC_PASSWORD_SET_MOBILE: 'PUBLIC_PASSWORD_SET_MOBILE',
    PUBLIC_PASSWORD_DELETE_MOBILE: 'PUBLIC_PASSWORD_DELETE_MOBILE',
    DISCOUNT_IN_OUTFLOW_MODAL: 'DISCOUNT_IN_OUTFLOW_MODAL',
    REPEAT_PURCHASE_MOBILE: 'REPEAT_PURCHASE_MOBILE',
    // tempexp_17906-next-line
    TARIFF_FEATURES_LIST_MOBILE: 'TARIFF_FEATURES_LIST_MOBILE',
    // tempexp_17905-start
    RESTORE_TRASHBIN_FILES_MODAL: 'RESTORE_TRASHBIN_FILES_MODAL',
    RESTORE_TRASHBIN_FILES_THANKS_MODAL: 'RESTORE_TRASHBIN_FILES_THANKS_MODAL',
    // tempexp_17905-end
    // tempexp_17360-next-line
    UPSALE_BONUS_MODAL: 'UPSALE_BONUS_MODAL',
    NO_SPACE_FOR_OVERQUOTA_USER_MODAL: 'NO_SPACE_FOR_OVERQUOTA_USER_MODAL',
    // tempexp_18090-start
    TARIFF_POLL_MODAL: 'TARIFF_POLL_MODAL',
    TARIFF_POLL_SUCCESS_MODAL: 'TARIFF_POLL_SUCCESS_MODAL',
    // tempexp_18090-end
    // tempexp_18085-start
    USED_SPACE_POSTPAID_MODAL: 'USED_SPACE_POSTPAID_MODAL',
    USED_SPACE_POSTPAID_THANKS_MODAL: 'USED_SPACE_POSTPAID_THANKS_MODAL',
    // tempexp_18085-end
    PROMO_QUOTA_FAKEDOOR_MODAL: 'PROMO_QUOTA_FAKEDOOR_MODAL',
    // tempexp_18089_next-line
    PARTNERS_FAKEDOOR_MODAL: 'PARTNERS_FAKEDOOR_MODAL',
    // tempexp_18238_next-line
    FAMILY_AFTER_PURCHASE_MODAL: 'FAMILY_AFTER_PURCHASE_MODAL',
    // tempexp_17359-next-line
    SUBSCRIPTION_CANCEL_FAMILY: 'SUBSCRIPTION_CANCEL_FAMILY',
    SHARING_WEBLINK_COLLAPSED_USER_LIST: 'SHARING_WEBLINK_COLLAPSED_USER_LIST',
    CANCEL_AUTO_RENEW_CONFIRM_DIALOG: 'CANCEL_AUTO_RENEW_CONFIRM_DIALOG',
    BEFORE_PURCHASE_MODAL: 'BEFORE_PURCHASE_MODAL',
    BEFORE_RENEW_MODAL: 'BEFORE_RENEW_MODAL',
    THANKS_BALLOON: 'THANKS_BALLOON',
    EDITOR_RESTRICTION_MODAL: 'EDITOR_RESTRICTION_MODAL',
    FLEXIBLE_QUOTA_MODAL: 'FLEXIBLE_QUOTA_MODAL',
    AUTO_UPLOAD_BUY_DIALOG: 'AUTO_UPLOAD_BUY_DIALOG',
    // tempexp_18455-next-line
    ASIDE_POLL: 'ASIDE_POLL',
    // tempexp_18851-next-line
    PAID_USER_RETURN_MODAL: 'PAID_USER_RETURN_MODAL',
    EXTEND_QUOTA_OFFER_MODAL: 'EXTEND_QUOTA_OFFER_MODAL',
    EXTEND_QUOTA_OFFER_MOBILE_MODAL: 'EXTEND_QUOTA_OFFER_MOBILE_MODAL',
    ONBOARDING_QR: 'ONBOARDING_QR',
    // tempexp_18855-start
    CROSS_PROMO_VK_MUSIC_FAKEDOOR_MODAL: 'CROSS_PROMO_VK_MUSIC_FAKEDOOR_MODAL',
    CROSS_PROMO_VK_MUSIC_FAKEDOOR_MODAL_THANKS: 'CROSS_PROMO_VK_MUSIC_FAKEDOOR_MODAL_THANKS',
    CROSS_PROMO_VK_MUSIC_SEVERAL_SUBSCRIPTIONS_MODAL: 'CROSS_PROMO_VK_MUSIC_SEVERAL_SUBSCRIPTIONS_MODAL',
    // tempexp_18855-end
    AI_SET_FAKEDOOR_MODAL: 'AI_SET_FAKEDOOR_MODAL',
    AI_SET_OK_MODAL: 'AI_SET_OK_MODAL',
    // tempexp_18907-next-line
    DISCOUNT_AFTER_OUTFLOW_MODAL: 'DISCOUNT_AFTER_OUTFLOW_MODAL',
    // tempexp_18086-start
    REFERRAL_MODAL: 'REFERRAL_MODAL',
    REFERRAL_MODAL_PROMO: 'REFERRAL_MODAL_PROMO',
    FLEXIBLE_QUOTA_PROMO_MODAL: 'FLEXIBLE_QUOTA_PROMO_MODAL',
    REFERRAL_USER_MODAL: 'REFERRAL_USER_MODAL',
    REFERRAL_DISABLED_MODAL: 'REFERRAL_DISABLED_MODAL',
    // tempexp_18086-end
    MOBILE_DISABLE_DOWNLOAD: 'MOBILE_DISABLE_DOWNLOAD',

    // tempexp_18662-next-line
    PUBLIC_INFO: 'PUBLIC_INFO',
    OVERQUOTA_CLEAR_DELETE_CONFIRM: 'OVERQUOTA_CLEAR_DELETE_CONFIRM',

    // tempexp_18727_start
    SKIPPED_PAYMENT_MODAL: 'SKIPPED_PAYMENT_MODAL',
    SKIPPED_PAYMENT_FINAL_MODAL: 'SKIPPED_PAYMENT_FINAL_MODAL',
    // tempexp_18727_end
    // tempexp_17847-next-line
    DOWNLOAD_LIMITS: 'DOWNLOAD_LIMITS',

    // tempexp_18926-start
    AUTOUPLOAD_ONBOADING: 'AUTOUPLOAD_ONBOADING',
    AUTOUPLOAD_ONBOADING_FINAL: 'AUTOUPLOAD_ONBOADING_FINAL',
    // tempexp_18926-end
    PROMOCODE_MODAL: 'PROMOCODE_MODAL',
    UNLIMITED_UPLOAD_INFO_MODAL: 'UNLIMITED_UPLOAD_INFO_MODAL',
    FULLSCREEN_CLOUD: 'FULLSCREEN_CLOUD',
    // tempexp_19300-next-line
    DISCOUNT_ON_REMOVE_MODAL: 'DISCOUNT_ON_REMOVE_MODAL',

    VK_MUSIC_BUNDLE_MODAL: 'VK_MUSIC_BUNDLE_MODAL',
    VK_MUSIC_CONFIRM_MODAL: 'VK_MUSIC_CONFIRM_MODAL',
    VK_MUSIC_ANONYMOUS_CONFIRM_MODAL: 'VK_MUSIC_ANONYMOUS_CONFIRM_MODAL',
    VK_MUSIC_SUCCESS_MODAL: 'VK_MUSIC_SUCCESS_MODAL',
    VK_MUSIC_ERROR_MODAL: 'VK_MUSIC_ERROR_MODAL',
    VK_MUSIC_CANCEL_SUBS_MODAL_MOBILE: 'VK_MUSIC_CANCEL_SUBS_MODAL_MOBILE',
    // tempexp_19370-next-line
    PRIORITY_DOWNLOAD_MODAL: 'PRIORITY_DOWNLOAD_MODAL',

    PROMOCODE_MODAL_MOBILE: 'PROMOCODE_MODAL_MOBILE',

    TEXT_INPUT_MODAL: 'TEXT_INPUT_MODAL',
    // tempexp_19236-next-line
    SUBSCRIBED_TO_VIGBO_MODAL: 'SUBSCRIBED_TO_VIGBO_MODAL',
    FAMILY_DOCUMENTS_MODAL: 'FAMILY_DOCUMENTS_MODAL',
    BEAUTIFULL_ADDRESS_DIALOG: 'BEAUTIFULL_ADDRESS_DIALOG',

    VIGBO_WHATS_NEW: 'VIGBO_WHATS_NEW',
    UPSALE_MULTI_TARIFF: 'UPSALE_MULTI_TARIFF',

    // tempexp_19617-start
    UNLIMITED_DOCUMENTS_MODAL: 'UNLIMITED_DOCUMENTS_MODAL',
    UNLIMITED_DOCUMENTS_THANKS_MODAL: 'UNLIMITED_DOCUMENTS_THANKS_MODAL',
    UNLIMITED_DOCUMENTS_ASIDE_PROMO: 'UNLIMITED_DOCUMENTS_ASIDE_PROMO',
    // tempexp_19617-end

    AI_TARIFF_PROMO: 'AI_TARIFF_PROMO',

    PUBLIC_BENEFITS_OF_AUTHORIZATION_MODAL: 'PUBLIC_BENEFITS_OF_AUTHORIZATION_MODAL',
    /**
     * @expFlag 3promo-enabled-public-animated-trend-modal
     * @ticket CLOUDWEB-20130
     * @nextline
     */
    PUBLIC_ANIMATED_TREND_MODAL: 'PUBLIC_ANIMATED_TREND_MODAL',

    // модалки быстрой очистки
    FAST_CLEANER_MODAL: 'FAST_CLEANER_MODAL',
    FAST_CLEANER_CONFIRM: 'FAST_CLEANER_CONFIRM',
    FAST_CLEAN_LOADING_MODAL: 'FAST_CLEAN_LOADING_MODAL',
    FAST_CLEANER_SAFE: 'FAST_CLEANER_SAFE',

    UPSALE_SMALL_MODAL: 'UPSALE_SMALL_MODAL',
    UPSALE_SMALL_DIALOG: 'UPSALE_SMALL_DIALOG',
    TBANK_MODAL: 'TBANK_MODAL',

    // tempexp_19963-start
    OVERQUOTA_WARNING_MODAL: 'OVERQUOTA_WARNING_MODAL',
    OVERQUOTA_FILES_MODAL: 'OVERQUOTA_FILES_MODAL',
    // tempexp_19963-end
    FREEMIUM_ONBOARDING_MODAL: 'FREEMIUM_ONBOARDING_MODAL',
    FREEMIUM_FEATURES_MODAL: 'FREEMIUM_FEATURES_MODAL',
    FREEMIUM_ABOUT_MODAL: 'FREEMIUM_ABOUT_MODAL',
    FREEMIUM_UNLIMITED_SPACE_MODAL: 'FREEMIUM_UNLIMITED_SPACE_MODAL',

    DUPLICATES_REMOVE_GROUP_MODAL: 'DUPLICATES_REMOVE_GROUP_MODAL',
    DUPLICATES_REMOVE_ALL_MODAL: 'DUPLICATES_REMOVE_ALL_MODAL',
    DUPLICATES_MAIL_SPACE_PROMO_MODAL: 'DUPLICATES_MAIL_SPACE_PROMO_MODAL',
    DUPLICATES_REMOVE_LIMIT_MODAL: 'DUPLICATES_REMOVE_LIMIT_MODAL',
    DUPLICATES_REMOVE_LIMIT_WARNING_MODAL: 'DUPLICATES_REMOVE_LIMIT_WARNING_MODAL',

    /**
     * @expFlag auth-mobile-redirect-app-main-actions
     * @ticket CLOUDWEB-20237
     * @nextline
     */
    ALL_FUNCTIONS_IN_APP_MODAL: 'ALL_FUNCTIONS_IN_APP_MODAL',

    // Генерация фото по промпту. CLOUDWEB-20532
    FULLSCREEN_AI_GENERATION_IMAGE: 'FULLSCREEN_AI_GENERATION_IMAGE',
    AI_GENERATION_STYLES: 'AI_GENERATION_STYLES',
    AI_GENERATION_RESET_MODAL: 'AI_GENERATION_RESET_MODAL',
    CHECK_AB_MODAL: 'CHECK_AB_MODAL',
    ALL_DOCUMENTS_REQUEST_MODAL: 'ALL_DOCUMENTS_REQUEST_MODAL',
} as const;

export interface PopupHelper {
    closeDialog(): void;
}

export interface PopupStateData {
    name: string;
    data: any;
}

export interface IVirusDialogRequest {
    items: CloudItem | CloudItem[];
    actionName?: ActionName;
    name?: string;
    doNotChangeRoute?: boolean;
}
